import React, { useState } from "react";
import "./Manual.scss";
import { IoCloseCircleOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";

const Manual = () => {
  const navigate = useNavigate();

  return (
    <div className="manual-outer">
      <div className="manual-inner">
        <div className="manual-inner-icon">
          <IoCloseCircleOutline
            className="manual-inner-icon-inside"
            onClick={() => navigate(-1)}
          />
        </div>
        <div className="manual-inner-title">
          <h1 className="manual-inner-title-one">Твій пісенник пісень</h1>
          <h2 className="manual-inner-title-two">Як користуватися</h2>
          <p className="manual-text">
            Дуже раді вітати вас у нашому додатку й впевнені, що він стане
            корисним інструментом у вашій творчій діяльності!
          </p>
        </div>
        <div className="section offer-list">
          <h3 className="section-title"> Що можна робити у додатку</h3>
          <ul className="offer-list-ul">
            <li className="offer-list-item">
              Переглядати й вкористовувати будь-які пісенники із статусом
              &ldquo;загальний&ldquo;
            </li>
            <li className="offer-list-item">
              Створювати власні пісенники пісень
            </li>
            <li className="offer-list-item">
              Додавати учасників із правом редагування пісенника
            </li>
            <li className="offer-list-item">
              Завантажувати додаткові файли та медіа для кожної пісні
            </li>
            <li className="offer-list-item">
              Змінювати тональність в один клік
            </li>
            <li className="offer-list-item">
              Розподіляти пісні за категоріями
            </li>
            <li className="offer-list-item">
              Використовувати режим повного екрану
            </li>
            <li className="offer-list-item">Друкувати пісню у PDF</li>
            <li className="offer-list-item">
              Завантажувати свій пісенник у форматі docx
            </li>
            <li className="offer-list-item">
              Створювати індивідуальні добірки пісень
            </li>
            <li className="offer-list-item">
              Створювати групи для підбірок і запрошувати учасників
            </li>
            <li className="offer-list-item">Вибирати тарифний план</li>
            {/* <li className="offer-list-item">Завантажити свій пісенник у PDF</li> */}
          </ul>
        </div>
        <div className="section">
          <h3 className="section-title">Тарифні плани</h3>
          <p className="manual-text">
            Наразі тарифні плани відключені. Всі функції додатка у вільному
            доступі.
          </p>
          <p className="manual-text">
            У майбутньому у додатку можна буде вибрати один з трьох тарифних
            планів -{" "}
            <span className="highlight">
              Вильній, Індивідуальний, Командний.
            </span>{" "}
            Кожен зареєстрований користувач автоматично доєднується до тарифного
            плану <span className="highlight">Вільний</span>, який є
            безкоштовним. Переглянути умови тарифних планів можна на титульній
            сторінці додатку (натисніть логотип у лівому верхньому куті та
            перейдіть униз сторінки) або у{" "}
            <span className="highlight">Кабінеті</span>. Щоб перейти у Кабінет
            натисніть іконку профілю зврху біля свого імені. Перейти на більш
            розширений тарифний план можна буде у{" "}
            <span className="highlight">Кабінеті</span> у вкладці{" "}
            <span className="highlight">П/Д</span> (Персональні Дані).
            Переходити на розширені тарифні плани зможуть тільки зареєстровані
            користувачі.
          </p>
        </div>
        <div className="section">
          <h3 className="section-title">
            Що можна незареєстрованим користувачам
          </h3>
          <p className="manual-text">
            Незареєстровані у додатку користувачі можуть відкривати будь-який
            пісенник з переліку, переглядати пісні, користуватися зміною
            тональності та режимом повного екрану, відкривати наявні файли
            медіа.
          </p>
        </div>
        <div className="section">
          <h3 className="section-title">Як зареєструватись</h3>
          <p className="manual-text">
            Натисність кнопку <span className="highlight">Увійти</span> у
            верхньому правому куті та слідуйте вказівкам.
          </p>
        </div>
        <div className="section">
          <h3 className="section-title">Пісенники</h3>
          <p className="manual-text">
            Відкривати будь-який загальний пісенник можна з титульної сторінки
            додатка.
          </p>
          <p className="manual-text">
            <span className="highlight">Створення пісенника.</span>
            Тільки для зареєстрованих користувачів. Зайдіть у свій кабінет у
            вкладку <span className="highlight">Пісенники</span> і натисність{" "}
            <span className="highlight">Створити пісенник</span>. Введіть назву
            пісенника та виберить його статус -{" "}
            <span className="highlight">Приватний</span> чи
            <span className="highlight"> Загальний</span>.
            <span className="highlight"> Загальний</span> означає, що ваш
            пісенник буде доступний для переглядку у переліку пісень для всіх
            бажаючих.
            <span className="highlight"> Приватний</span> означає, що ваш
            пісенник буде з&apos;являтись тільки у вашому переліку пісень і у
            вашому кабінеті, більше ніхто його не бачитиме.
          </p>
          <p className="manual-text">
            Ви можете додати у свій пісенник учасників. Учасником може бути
            будь-який зареєстрований у додатку користувач. Учасник отримує право
            редагувати пісенник, тобто додавати, редагувати й видаляти пісні,
            завантажувати файли, але учасних не може змінювати дані про пісенник
            - назву, статус, інших учасників. Учасник зможе бачити цей пісенник у
            своєму кабінеті, і зможе відкривати його через свій кабінет.
          </p>
          <p className="manual-text">
            Кожен пісенник за замовчуванням має категорії, за якими можна
            розподіляти пісні. Категрії створені для християнських пісень. Якщо
            ви не хочете користуватись категоріями, виберіть{" "}
            <span className="highlight">Вимкнути категорії</span> і вони не
            будуть з&apos;являтися у цьому пісеннику.
          </p>
          <p className="manual-text">
            <span className="highlight">Редагування та видалення.</span>{" "}
            Редагувати інформацію про пісенник або видалити його може тільки
            власник, той хто створив пісенник. Для цього перейдіть у кабінет у
            вкладку Пісенники, натисніть назву потрібного пісенника та слідуйте
            вказівкам.
          </p>
          <p className="manual-text">
            <span className="highlight">Зміна власника.</span> Функція зміни
            власника у розробці.
          </p>
          <p className="manual-text">
            <span className="highlight">Завантаження пісенника у DOCX.</span> Ви
            можете завантажити весь свій пісенник у документ ворд. Натисність на
            пісенник і ви побачите цю функцію. Ми рекомендуємо періодично
            завантажувати пісенник на свій пристрій, як архів, для запобігання
            втрати інформації.
          </p>
        </div>
        <div className="section">
          <h3 className="section-title">Пісні</h3>
          <p className="manual-text">
            <span className="highlight">Додати пісню. </span>
            Щоб додати пісню, натисніть кнопку{" "}
            <span className="highlight">Додати пісню </span> у правому сайдбарі.
            (Якщо сайдбар схований, натисніть стрілочку, щоб його відкрити.) У
            формі для нової пісні введіть назву, виберіть тональність, введіть
            темп і розмір. Виберіть категорії (якщо вони увімкнені для цього
            пісенника) - можна вибрати декілька категорій. Введіть текст пісні з
            акордами. Дуже важливо правильно визначити тональність, інакше потім
            зміна тональності може відбуватися не коректно. Якщо ви хочете
            зкопіювати текст з іншого ресурсу, обов&apos;язково вставляйте текст
            as plain text. Для цього натистніть на праву кнопку миші у полі
            текстового редактора і знайдіть там insert as plain text. Після
            збереження пісні, якщо не всі рядки з акордами підсвічуються синім
            кольором, то видаліть такий рядок разом з попереднім і введіть
            акорди вручну.
            <span className="highlight"> Зберегти</span> внизу сторінки.
          </p>
          <p className="manual-text">
            <span className="highlight">Панель інструментів (тулбар).</span>{" "}
            Зверху назви пісні є тулбар з іконками, за допомогою яких можна
            ховати та показувати акорди, відкривати режим редагування, копіювати
            пісню у свій пісенник, вмикати режим повного екрану. Під тулбаром
            знаходяться стрілочки для керування розміром шрифта. Додаток
            запам&apos;ята ваші преференції щодо розміру шрифта та аккордів -
            показувати чи не показувати.
            <span className="highlight"> Сховати акорди</span> у тулбарі зверху.
          </p>
          <p className="manual-text">
            <span className="highlight">Акорди.</span> Після збереження пісні,
            текст у рядках з акордами підсвічується синім кольором. Інші
            терміни, такі як Приспів, Брідж и таке інше, краще виносити в окремі
            рядки. Майте на увазі, що акордів H та Hm не існує. Акорди Сі та Сі
            мінор позначаються буквами B та Bm. За замовучанням акорди пісні
            відображаться на екрані, але їх можна сховати. Для цього натисніть
            на іконку
            <span className="highlight"> Сховати акорди</span> у тулбарі зверху.
          </p>
          <p className="manual-text">
            <span className="highlight"> Замітки.</span>
            Якщо ви хочете додати замітки для музикантів стосовно аранжування
            пісні, винесіть їх в окремий рядок та поставте зірочку * на початку
            рядка. Тоді замітки будуть виділені зеленим кольором та вони не
            будуть показані не авторизованим користувачам. Авторизовані
            користувачі зможуть побачити ці замітки, якщо натиснуть на
            відповідну іконку у верхньому тулбарі. За замовчуванням замітки не
            відображаються. Не використовуйте круглі дужки для слів, які мають
            постійно відображатися на екрані.
          </p>
          <p className="manual-text">
            <span className="highlight">Редагувати пісню.</span> Для редагування
            пісні, відкрийте необхідну пісню й нажміть на іконку редагування у
            тулбарі зверху. У режимі редагування, ви можете змінти будь яку
            інформацю про пісню. Якщо ви оберете іншу тональність в режимі
            редагування, акорди зміняться автоматично. Якщо акорди не
            змінюються, спробуйте вибрати якусь іншу тональність, а потім знову
            ту, яка вам потрібна, і акорди зміняться. Якщо ви хочете виправити
            акорди, або вам не подобається, як вони змінилися автоматично,
            зробіть це вручну. Якщо ви невірно визначили тональність, то ви не
            можете просто вибрати іншу тональність в режимі редагування, тому що
            акорди в тексті будуть змінюватися відповідно. Щоб виправити
            тональність, скопіюйте текст пісні, очистіть текстовий редактор,
            змініть тональність, а потім вставте пісню назад as plain text. При
            зміні тональності в режимі редагування можуть додаватися зайві пусті
            рядки. Видаліть їх вручну.
          </p>
          <p className="manual-text">
            <span className="highlight">Видалити пісню.</span> Щоб видалити
            пісню, натисніть кнопку{" "}
            <span className="highlight">Видалити пісню</span> у правому
            сайдбарі.
          </p>
          <p className="manual-text">
            <span className="highlight">Завантажити медіа.</span> Для кожної
            пісні є можливість завантажити додаткові файли або посилання на
            медіа ресурси. Для цього натисніть{" "}
            <span className="highlight">Завантижати медія</span> у правому
            сайдбарі та слідуйте вказівкам. Файли будуть відображатися у правому
            сайдбарі під тими назвами, які ви введете для них у відповідному
            полі.
          </p>
        </div>
        <div className="section">
          <h3 className="section-title">Режим повного екрану</h3>
          <p className="manual-text">
            У режимі повного екрану можна переглядати окремі пісні (іконка
            екрану у верхньому тулбарі), а також добірки. Зверху є тулбар з
            іконками, якими можна змінювати формат відображення. Можна ховати і
            показувати акорди чи замітки. Можна керувати розімром шрифта. За
            замовчуванням всі пісні відоборажаються в одну колонку. Іконка з
            двома колонками дозволяє поділити пісню на дві колонки. В режимі
            повного екрану також можна змінювати тональність. Якщо ви відкрили в
            цьому режимі добірку, то всі іконки працюють окремо для кожної
            пісні, окрім другу у PDF. Якщо ви зареєстрований користувач, то у
            тулбарі у вас буде кнопка <span className="highlight">Save</span>.
            Ви можете зберегти свої налаштування для цієї пісні й вони будть
            автоматично підтягуватись.
          </p>
          <p className="manual-text">
            <span className="highlight"> Друк у PDF</span>. Друкувати у PDF
            можна тільки в режимі повного екрану. Ця функція відкриває пісню у
            новому вікні у форматі PDF, де її можна роздрукувати або збереги на
            ваш прийстрій. Якщо вам не подобається як пісня виглядає у PDF,
            спробуйте змінити форматування у режимі повного керану - збільшити
            чи зменшити шрифт, змінити кількість колонок - і спробуйте знову.
          </p>
        </div>
        <div className="section">
          <h3 className="section-title">Кабінет</h3>
          <p className="manual-text">
            Кожен зареєстрований користувач отримує власний кабінет для
            керування пісенниками, добірками, особистими даними. Для переходу у
            кабінет потрібного натиснути на іконку профілю наверху біля свого
            імені.
          </p>
        </div>
        <div className="section">
          <h3 className="section-title">Добірки</h3>
          <p className="manual-text">
            <span className="highlight">Добірки</span> призначені для того, щоб
            вибирати певну кількість пісень для виконання й відкривати їх у
            режимі повного екрану. Можна створювати скільки завгодно підбірок і
            груп підбірок.
          </p>
          <p className="manual-text">
            Для того, щоб створювати добірки, спочатку потрібно створити
            <span className="highlight"> групу.</span> Група може бути
            індивідувальною або тематичною, а може бути спільною. Будь-яку групу
            можна зробити спільною, якщо додати учасників. Учасники групи можуть
            створювати й редагувати добірки в цій групі. У Кабінеті у влкадці{" "}
            <span className="highlight">Добірки</span> натисніть{" "}
            <span className="highlight">Вибрати групу</span> і виберіть{" "}
            <span className="highlight">Створити групу</span>. Ви можете додати
            учасників до групи. Для цього знайдіть у пошуку учасника, натисніть
            іконку <span className="highlight">Перейти</span> у полі вводу -
            Ім&apos;я учасника з&apos;явиться внизу. Додайте стільки учасників,
            скільки потрібно. Якщо ви є учасником іншої групи, то ви можете
            відкрити цю групу з переліка груп і створювати в ній добірки. У
            майбутньому, користувачі плану{" "}
            <span className="highlight">Вільний</span> зможуть бути учасниками
            груп і створювати в них добірки, але не зможуть створювати власні
            групи підбірок. Якщо ви будете користувачем плану{" "}
            <span className="highlight">Індивідуальний</span>, то ви зможете
            створити групу для власного користування, але не зможете додати до
            неї учасників.
          </p>
          <p className="manual-text">
            Під час створення группи виберіть основний пісенник, з якого ви
            будете вибирати пісні в цій группі. Пісні цього пісенника будуть
            автоматично підтягуватись у вікно створення підбірок. Якщо ви
            захочете підібрати пісні з різних пісенників, ви можете вибрати інший
            пісенник під час створення добірки пісень.
          </p>
          <p className="manual-text">
            <span className="highlight">Добірки.</span>Якщо ви створили групу,
            або вас додали учасником до іншої групи, ви можете створювати,
            редагувати й видаляти добірки, змінювати порядок пісень у
            добірках. У віконці створення підбірок виберіть пісенник, а в полі
            вводу пісень, виберіть пісню й натисніть іконку переходу у полі
            вводу - пісня з&apos;явиться внизу. Натискайте стрілочки, щоб
            змінити порядок пісень.
          </p>
        </div>
        {/* <div className="section">
          <h3 className="section-title">Як припинити підписку</h3>
          <p className="manual-text">
            Якщо ви хочете припинити підписку, але у вас є пісенник, в якому
            більше 15 пісень, то ви можете завантижити ці пісні у PDF форматі,
            щоб не втратити їх. Якщо ви не будете видаляти пісенник, а просто
            припините підписку, то пісенник залишиться у базі даних, але ви
            будете мати доступ тільки до перших 15 пісень. Якщо ви видалите свій
            пісенник, всі пісні також будуть видалені. Підписка припиняється як
            тільки ви перестаєте вносити оплату. Так само легко її відновити -
            почати вносити оплату за своїм планом. Для того, щоб видалити свій
            акаунт у додатку повністю, зверніться у підтримку через телеграм бот
            (у футері додатка) або напишіть на електрону почту.
          </p>
        </div> */}
        <div className="section">
          <h3 className="section-title">Пропозиції</h3>
          <p className="manual-text">
            Якщо у вас є питання або пропозиції, ви можете звернутися у
            підтримку через телеграм групу (у футері додатка) або написати нам
            на електронну пошту (адреса у футері додатка).
          </p>
        </div>
        <h3 className="section-title">Приємного користування!</h3>
      </div>
    </div>
  );
};
export default Manual;
